import { __assign, __makeTemplateObject } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { BasicTable } from './components';
export var BasicTableResponsive = styled(function (props) {
    return React.createElement(BasicTable, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow-x: auto;\n"], ["\n  overflow-x: auto;\n"])));
BasicTableResponsive.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=BasicTableResponsive.js.map